import {observable, action, runInAction, computed} from 'mobx'
import { get, json } from '../../../utils/ajax'
import {handleSearchAndPage, setStore} from '../../../utils/Utils'

class CarsModelStore {

    @observable loading //页面是否加载
    @observable carsModelList//列表数据
    @observable pagination//分页器
    @observable searchFields//搜索框
    @observable editFields//新增、修改
    @observable modal //模态框是否显示
    @observable carseriesList//车系下拉框
    @observable modalTitle  //模态框名字

    constructor() {
        this.loading = false
        this.carsModelList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {}
        }
        this.searchFields = {
            carCode: '',
            code: ''
        }
        this.editFields = {
            id: '',
            carId: '',
            carCode: '',
            code: ''
        }
        this.modal = false
        this.carseriesList = []
        this.modalTitle = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }


    /** 车系模型列表 **/
    @action
    initCarsModelPage = async (page) => {
        this.loading = true
        let search = handleSearchAndPage(page, this.pagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carsModel/list`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.carsModelList = Array.isArray(res.content) ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 搜索框：平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            carCode: {value: this.searchFields.carCode},
            code: {value: this.searchFields.code}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onSearchFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let searchFields = {
            carCode: fields.carCode.value ? fields.carCode.value : '',
            code: fields.code.value ? fields.code.value : ''
        }
        this.searchFields = searchFields
    }

    /**
     * 搜索框：清空
     */
    @action
    clearSearchForm = () => {
        runInAction(() => {
            this.loading = this
            this.searchFields = {
                carCode: '',
                code: ''
            }
            this.loading = false
        })
    }

    /**
     * 首页选择车系下拉框
     * @returns {Promise.<void>}
     */
    @action
    initCarseries = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epcSparepart/queryCarList`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.carseriesList = res || []
            this.loading = false
        })
    }

    /**
     *  弹窗：显示
     *  record:  不存在:新增   存在：修改
     */
    @action showModal = (record) => {
        runInAction(() => {
            this.loading = true
            this.modal = true
            if (!record) {        //新增
                this.editFields = {
                    id: '',
                    carId: '',
                    carCode: '',
                    code: ''
                }
                this.modalTitle = '新增'
            } else {     //修改
                this.editFields = record
                this.modalTitle = '修改'
            }
            this.loading = false
        })
    }

    /**
     * 新增-修改 平行化
     * @returns {{name: {value: string}}}
     */
    @computed
    get fieldsEdit() {
        let editFields = {
            id: {value: this.editFields.id},
            carId: {value: this.editFields.carId},
            carCode: {value: this.editFields.carCode},
            code: {value: this.editFields.code}
        }
        return editFields
    }

    /**
     * 新增-修改 数据回写
     * @param changedFields
     */
    @action
    onEditFieldChange(changedFields) {
        const fields = {...this.fieldsEdit, ...changedFields}
        let editFields = {
            id: fields.id.value ? fields.id.value : '',
            carId: fields.carId.value ? fields.carId.value : '',
            carCode: fields.carCode.value ? fields.carCode.value : '',
            code: fields.code.value ? fields.code.value : ''
        }
        this.editFields = editFields
    }

    /**
     * 弹窗：关闭
     */
    @action
    closeModal = () => {
        runInAction(() => {
            this.loading = true
            this.editFields = {
                id: '',
                carId: '',
                carCode: '',
                code: ''
            }
            this.modal = false
            this.loading = false
        })
    }

    /**
     * 保存：新增/修改
     */
    @action saveCarsModel = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.editFields.id) {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carsModel/insert`, this.editFields)  //新增
        } else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carsModel/update`, this.editFields)  //修改
        }
        runInAction(() => {
            this.modal = false
            this.editFields = {}
            this.loading = false
        })
        this.initCarsModelPage(this.pagination.current)
    }

    /**
     * 删除
     * 栏目下有新闻是不允许删除栏目的
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    deleteCarsModel = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carsModel/delete/${id}`)
        this.initCarsModelPage(this.pagination.current)
        runInAction(() => {
            this.loading = false
        })
    }

}
export default new CarsModelStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/CarsModel/store.js